import { MediaUploadFormData } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-upload.component';
import { MediaType } from '~client/model/media-type';

/**
 * Transforms MediaUploadFormData to <File, string, MediaCreationRequest>
 * @param mediaType
 * @param values
 */
export const getUploadMediaRequest = (
  mediaType: MediaType,
  values: MediaUploadFormData,
): FormData => {
  const { file, folderName, description, width, height } = values;
  const formData = new FormData();

  const requestDataJson = JSON.stringify({
    mediaType,
    longDescription: description,
    width,
    height,
  });

  formData.append('file', file[0].value);
  formData.append('folderName', folderName);
  formData.append('requestData', new Blob([requestDataJson], { type: 'application/json' }));

  return formData;
};

/**
 * Transforms MediaUploadFormData to <File, string, number, MediaTranslationRequestItem>
 * @param mediaId
 * @param values
 */
export const getUploadMediaTranslationRequest = (
  mediaId: string,
  values: MediaUploadFormData,
): FormData => {
  const { file, folderName } = values;
  const formData = new FormData();

  const requestDataJson = JSON.stringify({
    locale: file[1].language,
  });

  formData.append('file', file[1].value);
  formData.append('folderName', folderName);
  formData.append('mediaId', mediaId);
  formData.append('requestData', new Blob([requestDataJson], { type: 'application/json' }));

  return formData;
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-overlay/helper/media-upload-request.helper.ts